(function ($) {
  "use strict";
  $.fn.contactForm = function () {
    $.each($(this), function (index, element) {
      var instance = {
        form: $(element),
        action: null,
        controls: [],
        validators: {
          'contact[Name]': {
            presence: true
          },
          'contact[Phone Number]': {
            presence: true
          },
          'contact[email]': {
            presence: true,
            email: true
          },
          'contact[How did you hear about us?]': {
            presence: true
          },
          'contact[Message]': {
            presence: true
          }
        },
        init: function () {
        	this.action = this.form.attr('action');
          	// this.form.attr('action', 'javascript:void(0);');
        	this.bindEvents();
          	this.initMasking();
        },
        initMasking: function () {
        	this.form.find('input[name="contact[Phone Number]"]').mask('(A00) 000-0000', {
              clearIfNotMatch: true,
              translation: {
                'A': {
                  pattern: /[2-9]/,
                  optional: false
                }
              }
            });
        },
        validate: function (e) {
          var validators = this.validators;
          var element = $(e.target);
          var fieldName = element.attr('name');
          // This will prevent revalidation on different event //
          
          if (fieldName && validators[fieldName])
          {
            var value = element.val() ? element.val() : null;
            var valid = !validate.single(value, validators[fieldName]);
            if (valid) {
              // Remove Error Class //
              element.removeClass('is-invalid');
            } else {
              // Add Error Class //
              element.addClass('is-invalid');
            }
          }
        },
        bindEvents: function () {
          var context = this;
          this.form.on('submit', function (e) {
            return context.proceed(e);
          });
          this.form.on('change', function (e) {
          	context.form.find('.form-message').remove();
          });
          $.each(this.form.find('[name]'), function (index, field) {
            var control = $(field);
            context.controls.push({
              control: control,
              name: control.attr('name')
            });
            control.on('focusout', function (e) {
              context.validate(e);
            });
            control.on('keyup', function (e) {
              context.validate(e);
            });
            control.on('change', function (e) {
              context.validate(e);
            });
          });
        },
        proceed: function (e) {
          this.form.find('.form-message').remove();
          var payload = {};
          var controls = {};
          this.form.find('.is-invalid').removeClass('is-invalid');
          for (var i = 0; i < this.controls.length; i++) {
            var obj = this.controls[i];
            controls[obj.name] = obj.control;
            payload[obj.name] = obj.control.val() ? obj.control.val() : null;
          }
          // Validation //
          var errors = validate(payload, this.validators, {format: 'detailed'});
          if (errors && errors.length > 0) {
            for (var i = 0; i < errors.length; i++) {
              if (controls[errors[i].attribute]) {
              	controls[errors[i].attribute].addClass('is-invalid');
              }
            }
            this.form.find('[name="utf8"]').after($('<p class="form-message form-message--error">Please fill up all required fields.</p>'));
            e.preventDefault();
            return false;
          }
          // Validation //
          /*$.ajax({
            url: this.action,
            method: 'POST',
            data: payload,
            success: function (response) {
            	console.warn(response);
            },
            error: function (error) {
            	console.error(error);
            }
          });*/
          
          return true;
        }
      };
      instance.init();
      $(element).data('global::ContactForm', instance);
    });
  };
  
  $('form.contact-form').contactForm();
})(jQuery);